import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

/**
 * confirmDialog - Exibe um dialog MUI de confirmação e retorna uma Promise<boolean>.
 * Respeita o modo escuro/claro detectando o tema atual do body.
 * Uso: const confirmed = await confirmDialog({ title, message });
 */
const confirmDialog = ({ title = "Confirmar", message = "Deseja continuar?" }) => {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);

    // Detectar modo escuro pelo localStorage (mesmo que o App.js usa)
    const preferredTheme = window.localStorage.getItem("preferredTheme") || "light";

    const theme = createTheme({
      palette: {
        type: preferredTheme === "dark" ? "dark" : "light",
      },
    });

    const cleanup = () => {
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
    };

    const handleConfirm = () => {
      cleanup();
      resolve(true);
    };

    const handleCancel = () => {
      cleanup();
      resolve(false);
    };

    const ConfirmDialog = () => (
      <ThemeProvider theme={theme}>
        <Dialog
          open={true}
          onClose={handleCancel}
          aria-labelledby="confirm-dialog-title"
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle id="confirm-dialog-title">
            {title}
          </DialogTitle>
          <DialogContent dividers>
            <Typography>{message}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} color="default" variant="contained">
              Não
            </Button>
            <Button onClick={handleConfirm} color="primary" variant="contained">
              Sim
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );

    ReactDOM.render(<ConfirmDialog />, container);
  });
};

export default confirmDialog;
